import QueryKey from '@/enums/QueryKey';
import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useRoleData() {
    const { data: roleOptions, isPlaceholderData: isPlaceholderDataRoleOptions } = useQuery({
        queryKey: [QueryKey.ROLE_OPTIONS],
        queryFn: async () => {
            const { data } = await axios.get(route('v2.users.roles.options'));
            return data;
        },
        placeholderData: [],
    });

    return {
        roleOptions,
        isPlaceholderDataRoleOptions,
    };
}
